/* global angular, _ */

var ngModule = angular.module('trends');

ngModule.service('DownloadManager', ['$q', '$timeout', 'Api', function ($q, $timeout, Api) {

    this.downloadStaticPpt =  function(item_id) {
        var deferred = $q.defer();
        Api.pptDownload.customGET('', {item_id: item_id}).then(function (response) {
            switch (response.status) {
                case 'finished':
                    deferred.resolve(response.download_link);
                    break;

                case 'download_warning':
                case 'blocked':
                    deferred.reject({
                        'status': response.status
                    });
                    break;

                default:
                    deferred.reject({
                        'status': 'error',
                        'errorMessage': response.message
                    });
                    break;
            }
        });

        return deferred.promise;
    };

    this.downloadPptBuilder = function(item_id) {
        var deferred = $q.defer();

        // continually poll the generation function and deal with updates
        var updateStatus = function (status_url) {
            var _status_url = status_url;
            Api.pptBuilderDownload.status.post({ status_url: status_url }).then(function (response) {
                switch (response.state) {
                    case 'pending':
                        // Check status again soon
                        $timeout(_.partial(updateStatus, _status_url), 500);
                        break;
                    case 'login_redirect':
                        deferred.reject({
                            'status': 'login_redirect',
                            'redirect_url': response.redirect_url
                        });
                        break;
                    case 'finished':
                        deferred.resolve(response.ppt_url);
                        break;
                    default:
                        deferred.reject({
                            'status': 'error',
                            'errorMessage': response.error_msg
                        });
                        break;
                }
            }, function () {
                deferred.reject({
                    'status': 'failed'
                });
            });
        };

        // start the ppt generation
        Api.pptBuilderDownload.request.customGET('', {ppt_id: item_id}).then(function (response) {
            switch (response.status) {
                case 'running':
                    updateStatus(response.status_url);
                    break;
                case 'login_redirect':
                    deferred.reject({
                        'status': 'login_redirect',
                        'redirect_url': response.redirect_url
                    });
                    break;
                case 'download_warning':
                case 'blocked':
                    deferred.reject({
                        'status': response.status
                    });
                    break;
                default:
                    deferred.reject({
                        'status': 'error',
                        'errorMessage': response.message
                    });
                    break;
            }
        });

        return deferred.promise;
    };

    this.downloadPDF = function (type, id, params) {
        var deferred = $q.defer();

        // continually poll the generation function and deal with updates
        var updateStatus = function (status_url) {
            Api.pdf_download.status.post({ status_url: status_url }).then(function (response) {
                switch (response.state) {
                    case 'running': case 'queued':
                        // Update completion
                        deferred.notify(parseInt(response.percent_complete));
                        // Check status again soon
                        $timeout(_.partial(updateStatus, response.status_url), 500);
                        break;

                    case 'finished':
                        deferred.resolve(response.pdf_url);
                        break;

                    default:
                        deferred.reject({
                            'status': 'error',
                            'error': response.error_msg
                        });
                        break;
                }
            }, function () {
                deferred.reject({
                    'status': 'failed'
                });
            });
        };

        // start the pdf generation
        Api.pdf_download[type].customGET(id, params).then(function (response) {
            var responseStatus = response.pdf_status || response.status;
            switch (responseStatus) {
                case 'running': case 'queued':
                    updateStatus(response.pdf_status_url);
                    break;

                case 'finished':
                    deferred.resolve(response.pdf_url);
                    break;

                case 'download_warning':
                case 'blocked':
                    deferred.reject({
                        'status': response.status
                    });
                    break;

                default:
                    deferred.reject({
                        'status': 'error',
                        'errorMessage': response.message
                    });
                    break;
            }
        });

        return deferred.promise;
    };
}]);
